import { Component } from '@angular/core';

import { PagePlaceholderComponent } from '../../../core/components/page-placeholder/page-placeholder.component';

@Component({
  selector: 'app-names-of-allah',
  imports: [PagePlaceholderComponent],
  templateUrl: './names-of-allah.component.html',
  styleUrl: './names-of-allah.component.scss'
})
export class NamesOfAllahComponent {
  protected readonly icon = 'الله';
  protected readonly pageTitle = 'pages.names_of_allah.title';
  protected readonly subtitle = 'pages.names_of_allah.subtitle';
}
